import IconButton from 'lib/components/buttons/icon-button'
import Button from 'components/core/button'
import { X, Plus } from 'lucide-react'
import { cn } from 'lib/util/cn'

interface BillingModalProfessionalServicesProps {
  professionalServices: boolean
  setProfessionalServices: (value: boolean) => void
  period: string
  disabled: boolean
}

export default function BillingModalProfessionalServices({
  professionalServices,
  setProfessionalServices,
  period,
  disabled,
}: BillingModalProfessionalServicesProps) {
  return (
    <div className={cn(disabled && 'tw-pointer-events-none tw-opacity-50')}>
      <div
        className={cn(
          'tw-flex tw-h-[4.5rem] tw-justify-between tw-rounded tw-border tw-border-solid tw-p-4',
          professionalServices ? 'tw-border-cornflower-300 tw-bg-neutral-50' : 'tw-border-neutral-200',
        )}
      >
        <div>
          <div className="tw-font-semibold tw-text-peppercorn-900">Professional services</div>
          <div>Description placeholder</div>
        </div>
        {professionalServices ? (
          <IconButton color="secondary" onClick={() => setProfessionalServices(false)}>
            <X />
          </IconButton>
        ) : (
          <div className="tw-flex tw-items-center">
            <div className="tw-w-24 tw-text-right">
              <div className="tw-font-semibold tw-text-peppercorn-900">+$999.00</div>
              <div>billed {period}</div>
            </div>
            <Button
              color="neutral"
              className="tw-ml-2"
              onClick={() => setProfessionalServices(true)}
              disabled={disabled}
            >
              <Plus />
              Add
            </Button>
          </div>
        )}
      </div>
    </div>
  )
}
